module.exports = __webpack_public_path__ + "img/tb@2x.cc7d9df9.png";